import React from 'react';
import { motion } from 'framer-motion';
import Button from '../../../components/ui/Button';
import { institutionSignupUrl } from '../institutionApp';

const InstitutionHeroSection = () => {
  const scrollToHowItWorks = () => {
    document.getElementById('how-it-works')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="relative isolate overflow-hidden bg-white pt-28 pb-16 sm:pt-32 lg:pb-24 lg:pt-36">
      <div className="lp-grain absolute inset-0 -z-10" />
      <div className="absolute -left-32 top-20 h-[420px] w-[420px] rounded-full bg-[var(--lp-accent)]/8 blur-[100px]" />
      <div className="absolute right-0 top-1/3 h-[300px] w-[300px] rounded-full bg-[var(--lp-accent)]/10 blur-[80px] dark:opacity-40" />

      <div className="mx-auto max-w-7xl px-5 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 28 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
          className="text-center max-w-5xl mx-auto"
        >
          {/* <div className="mb-6 inline-flex items-center gap-2 rounded-full border border-[var(--lp-line)] bg-white px-4 py-1.5 text-xs text-[var(--lp-ink-soft)]">
            <span className="flex h-2 w-2 rounded-full bg-emerald-500 animate-pulse" />
            For placement cells &amp; training teams
          </div> */}

          <h1 className="text-[2.75rem] leading-[1.05] tracking-tight text-[var(--lp-ink)] sm:text-6xl lg:text-[4rem]">
            Interview prep for your whole batch, <br className="hidden sm:block" />
            <span className="block text-[var(--lp-accent)]">at institution scale.</span>
          </h1>

          <p className="mt-6 max-w-2xl mx-auto text-lg leading-relaxed text-[var(--lp-ink-soft)] lg:text-[1.2rem]">
            One console for your placement cell: add students, allocate interview credits, design an AI mock interview once, and track completion and performance across every cohort — powered by the same prepxai engine students already trust.
          </p>

          <div className="mt-10 flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-center">
            <Button
              asChild
              size="lg"
              className="h-12 rounded-full bg-[var(--lp-accent)] px-8 text-sm text-white hover:bg-[var(--lp-accent)]/90"
              iconName="ArrowRight"
              iconPosition="right"
            >
              <a href={institutionSignupUrl()}>Get started</a>
            </Button>
            <button
              type="button"
              onClick={scrollToHowItWorks}
              className="inline-flex h-12 items-center justify-center gap-2 rounded-full border border-[var(--lp-line)] bg-transparent px-6 text-sm text-[var(--lp-ink)] transition-colors hover:bg-white"
            >
              See how it works
            </button>
          </div>

          <div className="mt-12 flex flex-wrap items-center justify-center gap-x-8 gap-y-4 text-[var(--lp-ink-soft)] text-sm">
            <span className="flex items-center gap-2">
              <span className="text-emerald-500">✓</span> Bulk CSV student import
            </span>
            <span className="flex items-center gap-2">
              <span className="text-emerald-500">✓</span> Reusable interview campaigns
            </span>
            <span className="flex items-center gap-2">
              <span className="text-emerald-500">✓</span> Live completion tracking
            </span>
            <span className="flex items-center gap-2">
              <span className="text-emerald-500">✓</span> Built on the prepxai engine
            </span>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default InstitutionHeroSection;
